import { React, useState, useEffect, useContext } from 'react'
import "../../../assets/css/table.css";
import Loading from "react-fullscreen-loading";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant"
import { AuthContext } from '../../../component/context/AuthContext';
import DatePicker from 'react-datetime';
import moment from 'moment';
import { FiDownload, FiCalendar, FiClock, FiCheckCircle, FiXCircle, FiBarChart2 } from 'react-icons/fi';

function MyLeavesCompoff() {
    const [authUserData] = useContext(AuthContext);
    const [fullLoading, setFullLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const [srchYear, setSrchYear] = useState(moment().format('YYYY'));
    const [srchMonth, setSrchMonth] = useState('');
    const [activeTab, setActiveTab] = useState('leaves');

    const [leaveData, setLeaveData] = useState([]);
    const [compoffData, setCompoffData] = useState([]);
    const [totalAllocated, setTotalAllocated] = useState(0);
    const [consumedCount, setConsumedCount] = useState(0);
    const [balanceCount, setBalanceCount] = useState(0);
    const [compoffApiCount, setCompoffApiCount] = useState(0);

    /* PAGINATION */
    const [perPage, setPerPage] = useState(10);
    const [maxPageLimit, setMaxPageLimit] = useState(10);
    const [minPageLimit, setMinPageLimit] = useState(0);

    let isToken = '';
    let userId = '';
    if (authUserData) {
        if (authUserData[0]) {
            isToken = authUserData[0].token ? authUserData[0].token : "";
            userId = authUserData[0].user_id ? authUserData[0].user_id : 0;
        }
    }

    useEffect(() => {
        if (isToken) fetchData();
    }, [isToken]);

    async function fetchData() {
        setLoading(true);
        const year = srchYear || moment().format('YYYY');
        const month = srchMonth || "";
        try {
            const [leavesRes, compoffRes] = await Promise.all([
                axios.post(CONST.LEAVES_BY_EMP_ID, {
                    id: userId, limit: 1000, page_number: 1, year, month,
                    search_input: { srchStatus: "", srchLeaveType: "", srchDateOfLeaves: "", srchDateOfLeavesApply: "" },
                    sort: { order: "desc", order_by: "id" }
                }, { headers: { Authorization: `Bearer ${isToken}` } }),
                axios.post(CONST.COMPOFF_BY_EMP_ID, {
                    user_id: userId, limit: 1000, page_number: 1, year, month,
                    srchCompOffDate: "", srchAppliedDate: "", status: "",
                    sort: { order: "desc", order_by: "id" }
                }, { headers: { Authorization: `Bearer ${isToken}` } })
            ]);
            setLeaveData(leavesRes.data.data || []);
            setCompoffData(compoffRes.data.data || []);
            setTotalAllocated(leavesRes.data.totalLeaveCount || 0);
            setConsumedCount(leavesRes.data.ConsumedLeaveCount || 0);
            setBalanceCount(leavesRes.data.BalanceLeaveCount || 0);
            setCompoffApiCount(leavesRes.data.compoffCount || 0);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
        setLoading(false);
    }

    const handleSearch = () => fetchData();
    const handleClear = () => {
        setSrchYear(moment().format('YYYY'));
        setSrchMonth('');
        setTimeout(() => fetchData(), 100);
    };

    const pendingCount = leaveData.filter(l => l.status == 0).length;
    const approvedCount = leaveData.filter(l => l.status == 1).length;
    const rejectedCount = leaveData.filter(l => l.status == 2).length;

    // Download search result Excel (2 sheets)
    const downloadExcel = async () => {
        try {
            setFullLoading(true);
            const response = await axios.post(
                CONST.DOWNLOAD_EMPLOYEE_REPORT,
                { emp_id: userId, year: srchYear || moment().format('YYYY'), month: srchMonth || "" },
                { headers: { 'Authorization': `Bearer ${isToken}` }, responseType: 'blob' }
            );
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `my_leaves_compoff_${srchYear || moment().format('YYYY')}${srchMonth ? '_' + srchMonth : ''}.xlsx`;
            link.click();
            setFullLoading(false);
            toast.success("Report downloaded successfully");
        } catch (error) {
            setFullLoading(false);
            toast.error("Error downloading report");
        }
    };

    // Download yearly summary (monthly breakdown)
    const downloadYearlyExcel = async () => {
        try {
            setFullLoading(true);
            const response = await axios.post(
                CONST.DOWNLOAD_EMPLOYEE_REPORT_YEARLY,
                { emp_id: userId, year: srchYear || moment().format('YYYY') },
                { headers: { 'Authorization': `Bearer ${isToken}` }, responseType: 'blob' }
            );
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `my_yearly_summary_${srchYear || moment().format('YYYY')}.xlsx`;
            link.click();
            setFullLoading(false);
            toast.success("Yearly report downloaded successfully");
        } catch (error) {
            setFullLoading(false);
            toast.error("Error downloading report");
        }
    };

    // Leave columns
    const leaveColumns = [
        {
            name: "Leave Type",
            cell: (row) => (
                <div className="d-flex py-1 align-items-center">
                    <div className="flex-fill pl-2">
                        <div className="font-weight-medium">{row.leave_type || '-'}</div>
                        <div className="text-muted"><small>{row.e_leave_type?.name || ''}</small></div>
                    </div>
                </div>
            ),
            width: "15%", wrap: true,
        },
        {
            name: "Date",
            cell: (row) => {
                const fromDate = row.from_date || row.leave_from_date;
                const toDate = row.to_date || row.leave_to_date;
                const isFullDay = row.leave_type === 'Full Day';
                const showTime = !isFullDay && row.from_time && row.to_time && row.from_time !== '00:00:00' && row.to_time !== '00:00:00';
                return (
                    <div className="d-flex py-1 align-items-center">
                        <div className="flex-fill pl-2">
                            <div className="font-weight-medium">
                                {fromDate ? moment(fromDate).format('DD-MM-YYYY') : '-'}
                                {isFullDay && toDate ? ' to ' + moment(toDate).format('DD-MM-YYYY') : ''}
                            </div>
                            <div className="text-muted"><small>
                                {isFullDay && row.no_of_days ? row.no_of_days + ' Day(s)' : ''}
                                {showTime ? 'Time: ' + row.from_time?.slice(0, 5) + ' - ' + row.to_time?.slice(0, 5) : ''}
                            </small></div>
                        </div>
                    </div>
                );
            },
            width: "20%", wrap: true,
        },
        {
            name: "Subject",
            cell: (row) => <span style={{ fontSize: '0.85rem' }}>{row.subject || ''}</span>,
            width: "25%", wrap: true,
        },
        {
            name: "Status",
            cell: (row) => {
                const map = { 0: { label: "Pending", bg: "#fffbeb", color: "#d97706" }, 1: { label: "Approved", bg: "#ecfdf5", color: "#059669" }, 2: { label: "Rejected", bg: "#fef2f2", color: "#dc2626" }, 3: { label: "Cancelled", bg: "#f1f5f9", color: "#94a3b8" } };
                const s = map[row.status] || map[0];
                return <span style={{ background: s.bg, color: s.color, padding: '3px 10px', borderRadius: 20, fontSize: '0.7rem', fontWeight: 600 }}>{s.label}</span>;
            },
            width: "12%",
        },
        {
            name: "Approver",
            cell: (row) => <span style={{ fontSize: '0.85rem' }}>{row.approvedByUser ? `${row.approvedByUser.first_name} ${row.approvedByUser.last_name}` : '-'}</span>,
            width: "20%", wrap: true,
        },
    ];

    // Comp-off columns
    const compoffColumns = [
        {
            name: "Type",
            cell: (row) => <span>{row.leave_type == 0 ? 'Half Day' : 'Full Day'}</span>,
            width: "15%",
        },
        {
            name: "Date",
            cell: (row) => <span>{row.compoff_date ? moment(row.compoff_date).format('DD-MM-YYYY') : '-'}</span>,
            width: "20%",
        },
        {
            name: "Subject",
            cell: (row) => <span style={{ fontSize: '0.85rem' }}>{row.UserstoCompoff?.subject || row.e_compoff?.subject || '-'}</span>,
            width: "30%", wrap: true,
        },
        {
            name: "Status",
            cell: (row) => {
                const status = row.UserstoCompoff?.status ?? row.e_compoff?.status ?? 0;
                const map = { 0: { label: "Pending", bg: "#fffbeb", color: "#d97706" }, 1: { label: "Approved", bg: "#ecfdf5", color: "#059669" }, 2: { label: "Rejected", bg: "#fef2f2", color: "#dc2626" } };
                const s = map[status] || map[0];
                return <span style={{ background: s.bg, color: s.color, padding: '3px 10px', borderRadius: 20, fontSize: '0.7rem', fontWeight: 600 }}>{s.label}</span>;
            },
            width: "15%",
        },
    ];

    const CustomLoader = () => (<div style={{ padding: "24px" }}><DivLoader color="primary" /></div>);

    const handlePageLimit = (val) => {
        setPerPage(parseInt(val));
        setMaxPageLimit(parseInt(val));
        setMinPageLimit(0);
    };

    /* BootyPagination - same as employee/List.js */
    const BootyPagination = ({ rowsPerPage, rowCount, onChangePage, currentPage }) => {
        function getNumberOfPages(rowCount, rowsPerPage) {
            return Math.ceil(rowCount / rowsPerPage);
        }
        const handleBackButtonClick = async () => {
            if ((currentPage - 1) % perPage === 0) {
                setMaxPageLimit(maxPageLimit - perPage);
                setMinPageLimit(minPageLimit - perPage);
            }
            onChangePage(currentPage - 1);
        };
        const handleNextButtonClick = async () => {
            if (currentPage + 1 > maxPageLimit) {
                setMaxPageLimit(maxPageLimit + perPage);
                setMinPageLimit(minPageLimit + perPage);
            }
            onChangePage(currentPage + 1);
        };
        const handlePageNumber = (e) => {
            onChangePage(Number(e.target.value));
        };
        let paginationText = "Page:  " + currentPage + ", Showing ";
        paginationText = paginationText + ((currentPage - 1) * perPage + 1) + " to " + Math.min(perPage * currentPage, rowCount);
        paginationText = paginationText + " of " + rowCount + " entries;";
        const pages = getNumberOfPages(rowCount, perPage);
        const pageItems = [];
        for (let i = 1; i <= pages; i++) pageItems.push(i);
        const nextDisabled = currentPage === pageItems.length;
        const previosDisabled = currentPage === 1;
        const pageNumbers = pageItems.map((page, index) => {
            if (page <= maxPageLimit && page > minPageLimit) {
                return (
                    <li key={index} className={`page-item ${currentPage === page ? "active" : ""}`}>
                        <button className={`page-link ${currentPage === page ? "active" : ""}`} onClick={handlePageNumber} value={page}>{page}</button>
                    </li>
                );
            }
            return null;
        });
        let pageIncrementEllipses = null;
        if (pageItems.length > maxPageLimit) {
            pageIncrementEllipses = (<li className="page-item" onClick={handleNextButtonClick}>&hellip;</li>);
        }
        let pageDecremenEllipses = null;
        if (minPageLimit >= 1) {
            pageDecremenEllipses = (<li className="page-item" onClick={handleBackButtonClick}>&hellip;</li>);
        }
        return (
            <div className='row card-footer'>
                <div className='col-md-4 align-self-center'>{paginationText}</div>
                <div className='col-md-8 text-align-right'>
                    <ul className="pagination pagination text-align-right float-right">
                        <li className="page-item">
                            <button className="page-link" onClick={handleBackButtonClick} disabled={previosDisabled} aria-disabled={previosDisabled} aria-label="previous page">«</button>
                        </li>
                        {pageDecremenEllipses}
                        {pageNumbers}
                        {pageIncrementEllipses}
                        <li className="page-item">
                            <button className="page-link" onClick={handleNextButtonClick} disabled={nextDisabled} aria-disabled={nextDisabled} aria-label="next page">»</button>
                        </li>
                    </ul>
                </div>
            </div>
        );
    };

    return (
        <>
            <Loading loading={fullLoading} background="rgba(0, 0, 0, 0.5)" loaderColor="#fff" />
            <div className="page-header d-print-none">
                <div className="container-xl">
                    <div className="row g-2 align-items-center">
                        <div className="col">
                            <div className="page-pretitle">Report</div>
                            <h2 className="page-title">My Leaves & Comp-Off</h2>
                        </div>
                    </div>
                </div>
            </div>

            {/* Stats Cards - same pattern as leaves/List.js */}
            <div className="container-xl mb-3">
                <div className="row g-2">
                    <div className="col-6 col-md-2">
                        <div className="db-stat-card">
                            <div className="db-stat-icon" style={{ background: "#dbeafe", color: "#1167e8" }}><FiCalendar size={18} /></div>
                            <div className="db-stat-value">{totalAllocated}</div>
                            <div className="db-stat-label">Total Leaves</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-2">
                        <div className="db-stat-card">
                            <div className="db-stat-icon" style={{ background: "#ffedd5", color: "#c2410c" }}><FiBarChart2 size={18} /></div>
                            <div className="db-stat-value">{consumedCount}</div>
                            <div className="db-stat-label">Used</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-2">
                        <div className="db-stat-card">
                            <div className="db-stat-icon" style={{ background: "#d1fae5", color: "#059669" }}><FiCheckCircle size={18} /></div>
                            <div className="db-stat-value">{balanceCount}</div>
                            <div className="db-stat-label">Balance</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-2">
                        <div className="db-stat-card">
                            <div className="db-stat-icon" style={{ background: "#fef3c7", color: "#b45309" }}><FiClock size={18} /></div>
                            <div className="db-stat-value">{pendingCount}</div>
                            <div className="db-stat-label">Pending</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-2">
                        <div className="db-stat-card">
                            <div className="db-stat-icon" style={{ background: "#fee2e2", color: "#dc2626" }}><FiXCircle size={18} /></div>
                            <div className="db-stat-value">{rejectedCount}</div>
                            <div className="db-stat-label">Rejected</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-2">
                        <div className="db-stat-card">
                            <div className="db-stat-icon" style={{ background: "#fef3c7", color: "#92400e" }}><FiClock size={18} /></div>
                            <div className="db-stat-value">{compoffApiCount}</div>
                            <div className="db-stat-label">Comp-Off</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-body">
                <div className="container-xl">
                    <div className="row row-cards">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Listing</h3>
                                </div>
                                <div className="card-body border-bottom py-3">
                                    <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group mb-3 ">
                                                <label className="form-label required">Year</label>
                                                <div>
                                                    <DatePicker value={srchYear} dateFormat="YYYY" timeFormat="" onChange={(val) => setSrchYear(val ? moment(val).format('YYYY') : '')} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group mb-3 ">
                                                <label className="form-label required">Month</label>
                                                <div>
                                                    <DatePicker value={srchMonth} dateFormat="MM" timeFormat="" onChange={(val) => setSrchMonth(val ? moment(val).format('MM') : '')} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="form-group mb-3 ">
                                                <label className="form-label">&nbsp;</label>
                                                <div>
                                                    <button type="button" className="btn btn-blue d-none d-sm-inline-block mr-2" onClick={handleSearch}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-search" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <circle cx="10" cy="10" r="7"></circle>
                                                            <line x1="21" y1="21" x2="15" y2="15"></line>
                                                        </svg>Search
                                                    </button>&nbsp;
                                                    <button type="button" className="btn btn-outline-primary mr-2" onClick={handleClear}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <line x1="18" y1="6" x2="6" y2="18"></line>
                                                            <line x1="6" y1="6" x2="18" y2="18"></line>
                                                        </svg>Clear
                                                    </button>&nbsp;
                                                    <button type="button" className="btn btn-outline-success mr-2" onClick={downloadExcel}>
                                                        <FiDownload size={16} />&nbsp;Export
                                                    </button>&nbsp;
                                                    <button type="button" className="btn btn-success" onClick={downloadYearlyExcel}>
                                                        <FiDownload size={16} />&nbsp;Yearly Report
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-6">
                                            <nav className="limit-pagination pt-3">
                                                <span className="">Rows per page:</span>
                                                <select aria-label="Rows per page:" className="sc-cwSeag jaZsat" value={perPage} onChange={(e) => handlePageLimit(e.target.value)}>
                                                    <option value="10">10</option>
                                                    <option value="20">20</option>
                                                    <option value="30">30</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>
                                            </nav>
                                        </div>
                                    </div>
                                </div>

                                {/* Tabs */}
                                <div className="card-header">
                                    <ul className="nav nav-tabs card-header-tabs">
                                        <li className="nav-item">
                                            <a className={`nav-link ${activeTab === 'leaves' ? 'active' : ''}`} href="#" onClick={(e) => { e.preventDefault(); setActiveTab('leaves'); }}>
                                                Leaves ({leaveData.length})
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={`nav-link ${activeTab === 'compoff' ? 'active' : ''}`} href="#" onClick={(e) => { e.preventDefault(); setActiveTab('compoff'); }}>
                                                Comp-Off ({compoffData.length})
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="table-responsive">
                                    {activeTab === 'leaves' && (
                                        <DataTable
                                            columns={leaveColumns}
                                            data={leaveData}
                                            progressPending={loading}
                                            progressComponent={<CustomLoader />}
                                            noDataComponent={<div className="text-muted py-3">No leave records found</div>}
                                            pagination="true"
                                            paginationPerPage={perPage}
                                            paginationComponent={BootyPagination}
                                        />
                                    )}
                                    {activeTab === 'compoff' && (
                                        <DataTable
                                            columns={compoffColumns}
                                            data={compoffData}
                                            progressPending={loading}
                                            progressComponent={<CustomLoader />}
                                            noDataComponent={<div className="text-muted py-3">No comp-off records found</div>}
                                            pagination="true"
                                            paginationPerPage={perPage}
                                            paginationComponent={BootyPagination}
                                        />
                                    )}
                                </div>
                                <div className="card-footer d-flex align-items-center">
                                    <p className="m-0 text-muted">
                                        Showing <span>{activeTab === 'leaves' ? leaveData.length : compoffData.length}</span> entries
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MyLeavesCompoff
